import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Comment = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 23"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          d="M14.5 1h-5A8.5 8.5 0 0 0 1 9.5c0 4.182 3.022 7.65 7 8.36V22l6-4h.5a8.5 8.5 0 0 0 0-17z"
          stroke={props.color || theme.palette.grey600}
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M15.001.001h-6a9 9 0 0 0-9 9c0 4.282 2.993 7.859 7 8.769v6.231l7-6h1c4.971 0 9-4.029 9-9s-4.029-9-9-9z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
